export default {
  actions: {
    add: 'Add',
    addComment: 'Add a CODE Insight',
    addThreadComment: 'Add your comment',
    addReply: 'Add a reply',
    back: 'Back',
    cancel: 'Cancel',
    comment: 'Comment',
    delete: 'Delete',
    capture: 'Capturer',
    close: 'Close',
    confirm: 'Confirm',
    disconnect: 'Log out',
    connect: 'Log in',
    emitReport: 'Émettre le rapport',
    notifications: 'Notifications',
    qualify: 'À nuencer',
    reject: 'À rejeter',
    reply: 'Reply',
    remember: 'À retenir',
    save: 'Save',
    share: 'Share',
    search: 'Search',
    create: 'Create',
    validate: 'À valider',
    shareWithPeopleOrGroup: 'Share with people, formal groups or thinking spaces',
    addPeopleOrGroup: 'Add with people, formal groups or thinking spaces.',
    noResult: 'No result',
    linkToReflection: 'Add to reflection bibliography',
  },
  errors: {
    generic: 'An error occured, please try again.',
    errorOccuredContactUsIfPersists: 'An erro occured, please contact support if the problem persists.',
  },
  documentUpload: {
    action: 'Upload document',
    title: 'Document upload',
    uploadAndNext: 'Upload and go to analysis',
    redirecting: 'Redirecting to NOOS analysis...',
    errors: {
      creation: `An error occured when creating the document's analysis.
      Please try again or contact support is the problem persists.`,
      noEmpty: 'Field cannot be empty',
    },
  },
  permissions: {
    Owner: 'Owner',
  },
  dialogs: {
    quit: {
      header: 'Avertissement',
      description: 'Voulez-vous vraiment quitter?\n(Attention! Toutes les modifications non sauvegardées seront perdues.)', // eslint-disable-line
    },
  },
  captureDocument: {
    checkbox: {
      downloadAuthorized: 'Télécharger le contenu',
    },
    textField: {
      addDocumentTitle: 'Ajouter un titre au document',
      addDocumentDescription: 'Ajouter une description au document',
    },
    legal: 'NOOS est un outil d’analyse et de sensemaking qui peut être utilisé en ligne à partir d’un site original. L’usager est tenu de respecter les droits d’auteurs lors de l’utilisation de l’outil : veuillez vous assurer qu’un contenu est libre de droits et peut être rediffusé ou que vous détenez les droits requis avant tout téléchargement de contenu protégé.', // eslint-disable-line
    analysisCreated: "Création de l'analyse réussie",
    analysisCreationFailed: 'Erreur lors la création, communiquez avec nous si le problème persiste.',
  },
  evaluationForm: {
    actions: {
      addSelectedText: 'Ajouter le texte sélectionné',
    },
    headers: {
      evaluation: 'Évaluation',
      generalValue: 'Valeur général',
      significantElements: 'Highlight',
    },
    toggles: {
      detailed: {
        on: "Masquer l'évaluation détaillée",
        off: 'Faire une évaluation détaillée',
      },
    },
    tooltips: {
      addSelectedText: 'Pour ajouter un élement significatif,\n sélectionnez une portion de texte sur la\n page web et cliquez sur le bouton "Ajouter\n le texte sélectionné". Choisissez ensuite\n comment le classifier avec les options "!", "?", "-"', // eslint-disable-line
      qualify: 'Permet d\'identifier un élément de contenu qui vous semble pertinent mais qui doit faire l\'objet d\'une validation plus avancée, être complété ou être nuancé.', // eslint-disable-line
      remember: 'Permet d\'identifier un élément de contenu jugé particulièrement pertinent à considérer dans les réflexions et décisions.', // eslint-disable-line
      validate: 'Permet d\'identifier un élément de contenu qui vous semble contestable voire potentiellement non fondé. Ces types d\'éléments contribuent à mieux comprendre le contexte général. Ils seront évités comme fondement de prise de décision s\'ils ne peuvent être validés ou, à titre d\'exemple, ils serviront à mieux cerner l\'argumentaire requis pour répondre à une perception potentiellement erronée.', // eslint-disable-line
      evaluation: 'Permet d\'évaluer la valeur d\'un document selon son apport potentiel pour faire avancer les réflexions en lien avec les objectifs priorisés.  Votre évaluation indiquera à Noos s\'il doit s\'inspirer de cette information pour vous alimenter en prochaine information.', // eslint-disable-line
      generalValue: 'L\'information est pertinente pour soutenir et faire progresser les réflexions en lien avec les objectifs.', // eslint-disable-line
      significantElements: 'Permet de mettre en relief un segment de texte dont le contenu a une importance particulière.',
    },
  },
  footer: {
    p: {
      0: 'Noos Extension version {{version}}',
      1: '© Noos Technologie {{year}}',
      2: 'All rights reserved',
    },
  },
  globals: {
    similarDocuments: 'Similar documents',
    loading: 'Loading',
    category: {
      plural: 'Categories',
      single: 'Catégory',
    },
    description: 'Description',
    group: {
      plural: 'Groups',
      single: 'Group',
    },
    email: 'Email',
    password: 'Password',
    report: {
      plural: 'Rapports',
      single: 'Rapport',
      withCount: '{count} rapports',
    },
    reply: {
      plural: 'Réponses',
      single: 'Réponse',
      withCount: '{count} réponses',
    },
    title: 'Title',
    unclassified: 'Non classé',
    user: {
      plural: 'Users',
      single: 'User',
      withCount: '{count} Users',
    },
    reflection: {
      single: 'Reflection',
      plural: 'Reflections',
    },
    search: 'Search',
  },
  mainSections: {
    portfolio: {
      short: 'Portfolio',
      long: 'Knowledge Portfolio',
    },
    journal: {
      short: 'Watch',
      long: 'Info Watch',
    },
    reflection: {
      short: 'Thinking',
      long: 'Thinking Zone',
    },
  },
  list: {
    categories: {
      additionalInfos: 'Information additionnel',
      general: 'Objectif général',
      objectives: 'Objectifs',
      strategies: 'Stratégies',
      tactics: 'Tactiques',
    },
    emission: {
      reports: {
        emitted: 'Rapport émis le {date}',
        current: 'Rapport actuel',
      },
    },
    retention: {
      document: {
        actions: {
          considered: 'Considérer le document',
          notRetained: 'Ne pas retenir ce document',
          retained: 'Retenir ce document',
        },
        selected: {
          considered: 'Considéré',
          notRetained: 'Non retenu',
          retained: 'Retenu',
        },
      },
    },
  },
  ratings: {
    names: {
      criticalUrgency: 'Critique',
      feasibility: 'Faisabilité',
      learningProcessImprovement: 'Apprentissage',
      mobilisation: 'Mobilisation',
      noveltyComplementarity: 'Nouveauté',
      operationalization: 'Opérationnalisation',
      relevanceUsefulness: 'Cohérence stratégique',
      resolution: 'Résolution',
      validityCredibility: 'Validité',
    },
    tooltips: {
      criticalUrgency: 'L\'information nécessite une réflexion rapide ou une action urgente en raison de son impact majeur potentiel sur les objectifs', // eslint-disable-line
      feasibility: 'L\'information propose des pistes de solutions pouvant être réalistement mises en œuvre au sein de notre organisation', // eslint-disable-line
      learningProcessImprovement: 'L\'information propose des leçons issues d\'expériences réelles permettant de revalider, optimiser ou recalibrer les orientations, stratégies ou moyens en cours ', // eslint-disable-line
      mobilisation: 'L\'information propose des stratégies, moyens, outils, ressources pouvant soutenir la mobilisation des parties prenantes envers les objectifs', // eslint-disable-line
      noveltyComplementarity: 'L\'information apporte de nouvelles perspectives ou idées pour mieux comprendre le contexte ou pour explorer différemment comment atteindre les objectifs', // eslint-disable-line
      operationalization: 'L\'information fournit des stratégies, moyens, outils, ressources pouvant être utilisés ou implantés immédiatement pour soutenir l\'avancement vers les objectifs', // eslint-disable-line
      relevanceUsefulness: 'L\'information est en lien étroit avec les objectifs visés et est susceptible d\'impacter les décisions et orientations', // eslint-disable-line
      resolution: 'L\'information offre des pistes de solution concrètes permettant de résoudre partiellement ou complètement une problématique empêchant d\'avancer efficacement sur les objectifs', // eslint-disable-line
      validityCredibility: "L'information est issue d'une source crédible et peut être vérifiée",
    },
  },
  reflectionForm: {
    analysisCard: {
      insertDoc: {
        quote: 'Insert as citation',
        support: 'Insert as reference',
      },
    },
    headers: {
      reflection: 'Réflexion',
      readOnly: 'Read-Only',
    },
    tooltips: {
      c: 'Clarification (C) : Expliquez pourquoi cette information vous apparaît utile pour mieux avancer vers les objectifs ou en quoi elle pourrait impacter les décisions ou orientations actuelles (les remettre en question ou les consolider).', // eslint-disable-line
      o: 'Option (O):  Partagez les idées nouvelles que vous avez détectées dans le document ou qui vous sont inspirées par cette information, et qui pourraient potentiellement aider à rencontrer les objectifs visés.', // eslint-disable-line
      d: 'Développement (D):   Identifiez des idées, stratégies et moyens permettant de développer ou renforcer une solution potentielle ou en cours afin d\'en réduire le risque ou d\'en faciliter une implantation à succès', // eslint-disable-line
      e: 'Expérimentation (E):  Identifiez ou partagez des outils, résultats et leçons apprises facilitant et accélérant la planification, la mesure, les suivis et l\'adaptation d\'actions en cours ou futures.', // eslint-disable-line
      reflection: 'Permet de contribuer par votre analyse personnelle à identifier comment utiliser l\'information pour soutenir les prochaines avancées de réflexions ou les actions.', // eslint-disable-line
    },
    reloadPanel: {
      message: {
        newSchema: 'A new version of the editor schema is available, please reload the application...',
        connectionError: "Can't reach the collaboration server. If the problem persist, please contact support.", //eslint-disable-line
        accessDenied: 'You don\'t have the required permission to access this document.',
        unknown: 'An unknown error occurred. If the problem persist, please contact support.',
      },
      buttonCaption: 'Reload',
    },
  },
  shareForm: {
    headers: {
      share: 'Partage',
    },
    textField: {
      sharingMessageField: 'Ajouter un message pour le partage',
    },
  },
  validation: {
    alpha: 'Le champ {_field_} ne peut contenir que des lettres',
    alpha_num: 'Le champ {_field_} ne peut contenir que des caractères alpha-numériques',
    alpha_dash: 'Le champ {_field_} ne peut contenir que des caractères alpha-numériques, tirets ou soulignés',
    alpha_spaces: 'Le champ {_field_} ne peut contenir que des lettres ou des espaces',
    between: 'Le champ {_field_} doit être compris entre {min} et {max}',
    confirmed: 'Le champ {_field_} ne correspond pas',
    digits: 'Le champ {_field_} doit être un nombre entier de {length} chiffres',
    dimensions: 'Le champ {_field_} doit avoir une taille de {width} pixels par {height} pixels',
    email: 'Le champ {_field_} doit être une adresse e-mail valide',
    excluded: 'Le champ {_field_} doit être une valeur valide',
    ext: 'Le champ {_field_} doit être un fichier valide',
    image: 'Le champ {_field_} doit être une image',
    integer: 'Le champ {_field_} doit être un entier',
    length: 'Le champ {_field_} doit contenir {length} caractères',
    max_value: 'Le champ {_field_} doit avoir une valeur de {max} ou moins',
    max: 'Le champ {_field_} ne peut pas contenir plus de {length} caractères',
    mimes: 'Le champ {_field_} doit avoir un type MIME valide',
    min_value: 'Le champ {_field_} doit avoir une valeur de {min} ou plus',
    min: 'Le champ {_field_} doit contenir au minimum {length} caractères',
    numeric: 'Le champ {_field_} ne peut contenir que des chiffres',
    oneOf: 'Le champ {_field_} doit être une valeur valide',
    regex: 'Le champ {_field_} est invalide',
    required: 'Le champ {_field_} est obligatoire',
    required_if: 'Le champ {_field_} est obligatoire lorsque {target} possède cette valeur',
    size: 'Le champ {_field_} doit avoir un poids inférieur à {size}KB',
    double: 'Le champ {_field_} doit être une décimale valide',
  },
  views: {
    accesses: 'Accesses',
    notifications: {
      analysisModified: {
        body: 'modified',
      },
      analysisShared: {
        body: 'shared',
      },
      missionAssigned: {
        body: 'assigned a mission to you',
      },
      missionAccomplished: {
        body: 'accomplished the mission',
      },
    },
    analysis: {
      commentBy: 'Commented by',
      highlightBy: 'Highlighted by',
      foundBy: 'Found by',
      ficheInfoLinkName: 'document',
    },
  },
  mission: {
    fulfill: 'Accomplir ma mission',
    errorMissingAssignee: 'Vous devez assigner des collègues à votre mission.',
    errorMissingMission: 'Vous devez définir une mission.',
    visibilityWarning: 'Missions are visible to all participants of this thread.',
  },
  analysis: {
    tags: 'Tags',
    reflexions: 'Réflections',
    noReflexion: 'Aucune réflexion',
    participants: 'Participants',
    likedReflexions: 'Reflections linked to analysis ({count})',
  },
  components: {
    ExpressAnalysis: {
      success: 'Saved successfuly',
    },
    CreateDocumentFromUpload: {
      error: 'Erreur while uploading document',
    },
    fileUploader: {
      uploading: 'Uploading: ',
    },
    pdfViewer: {
      showAllPages: 'Show all pages',
      loading: 'Loading document...',
    },
  },
  extension: {
    summary: {
      title: 'Team analysis',
      threads: 'No other thread | 1 other thread | {count} other threads',
      participants: 'Thread members',
      tags: 'Tags',
      evaluationTitle: 'Relevancy',
      topElementsTitle: 'Top analyses',
      evaluation: 'No evaluation | 1 evaluation | {count} evaluations',
      emptySummaryText: 'Be the first to analyze this document',
      goToTopElement: 'Go to top analysis',
      commented: 'Comment added',
      highlightedElement: 'Element highlighted',
      addedElement: 'Element added',
    },
    userAnalyses: {
      allAnalyses: 'All analyses',
      myAnalysis: 'My analysis',
      evaluation: 'Relevancy',
      newThread: 'Start an analysis thread',
      accomplishedMissions: 'accomplished their mission',
      description: 'Start your analysis in this section',
      events: {
        modified: 'Modified',
        created: 'Created',
        highlighted: 'Highlighted',
        added: 'Added',
        commented: 'Commented',
      },
      highlights: {
        title: 'Highlight',
        tooltip: 'Select significant information.',
      },
      comments: {
        title: 'CODE Insights',
        tooltip: "Add your analysis. Select the corresponding CODE letter to explain it's specific contribution.",
        reply: {
          placeholder: 'Share your reflection...',
        },
        showMore: 'Show 1 more CODE Insight | Show {nbComments} more CODE Insights',
        hide: 'Hide 1 CODE Insight | Hide {nbComments} more CODE Insights',
      },
      missions: {
        title: 'Analysis Mission : What do you think?',
        tooltip: 'Add a message or create an analysis mission',
      },
    },
    footer: {
      seeMyAnalysis: 'View my analysis',
      addMyAnalysis: 'Add my analysis to the thread',
      sendButton: {
        linkReflection: {
          aclConfirmationDialog: {
            title: 'Authorize new participants',
            descriptionUser: "The following users don't have the required access to the selected thread :",
            descriptionGroup: "The following groups don't have the required access to the selected thread :",
            confirmButtonLabel: 'Give access and create',
            cancelButtonLabel: 'Cancel',
          },
        },
      },
    },
    analysisSelector: {
      contributionsSingular: 'contribution',
      contributionsPlural: 'contributions',
    },
  },
};
